import React, { ReactElement } from 'react';
import QRCode from 'react-qr-code';

import { useWindowWidth } from '@auspost/mpc-uikit-hooks';
import { Button, Heading, Modal } from '@auspost/postmaster-react';

import styles from './QrCodeModal.module.scss';

export interface QrCodeModalProps {
  qrCode: string;
  isOpen: boolean;
  heading: string;
  content: ReactElement;
  notification?: ReactElement;
  handleClose: () => void;
}

const QrCodeModal: React.FC<QrCodeModalProps> = ({ qrCode, isOpen, heading, content, handleClose, notification }) => {
  const { isExtraSmallScreenOrLess } = useWindowWidth();

  return (
    <Modal
      isModalShowing={isOpen}
      onHide={handleClose}
      modalClassName={styles.qrCodeModal}
      dialogClassName={styles.qrCodeDialog}
      ariaDialogLabel='QR code modal'
      dialogId='QR code modal'
    >
      <Modal.Header closeButton={true} className={styles.modalHeader}>
        <Heading level='h3'>{heading}</Heading>
      </Modal.Header>
      <Modal.Content className={styles.content}>
        {notification && <div className={styles.notification}>{notification}</div>}
        <div className={styles.qrCode}>
          <QRCode value={qrCode} size={isExtraSmallScreenOrLess ? 210 : 200} aria-label={heading} />
        </div>
        {content}
      </Modal.Content>
      <Modal.Footer alignment='center' className={styles.modalFooter}>
        <Button onClick={handleClose} size='medium' variant='primary' className={styles.closeButton}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QrCodeModal;
